"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetClientSupplyList = void 0;
const Base_1 = require("./Base");
exports.GetClientSupplyList = {
    url: Base_1.URL_BASE + "/GetClientSupplyList",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetClientSupplyList.js.map